type NameHaver =
  | {
      firstName?: string | null
      lastName?: string | null
      company?: string | null
    }
  | {
      name: string | null
      company: string | null
    }

export default function displayName(user: NameHaver) {
  if ('name' in user) {
    if (user.name && user.company) {
      return `${user.name}, ${user.company}`
    } else {
      return user.name || user.company || '–'
    }
  }

  if (user.firstName && user.lastName && user.company) {
    return user.firstName + ' ' + user.lastName + ', ' + user.company
  } else if (user.firstName && user.lastName) {
    return user.firstName + ' ' + user.lastName
  } else if (user.lastName && user.company) {
    return user.lastName + ', ' + user.company
  } else if (user.lastName) {
    return user.lastName
  } else if (user.company) {
    return user.company
  } else {
    return '–'
  }
}
